import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f13c6846&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13c6846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f13c6846')) {
      api.createRecord('f13c6846', component.options)
    } else {
      api.reload('f13c6846', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f13c6846&scoped=true&", function () {
      api.rerender('f13c6846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/active/question/index.vue"
export default component.exports